import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 3h8a2 2 0 0 1 2 2v14.936a1 1 0 0 1-1.62.785L12 17.263l-4.38 3.458A1 1 0 0 1 6 19.936V5a2 2 0 0 1 2-2m5 4a1 1 0 1 0-2 0v2H9a1 1 0 0 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2z",
      clipRule: "evenodd"
    }
  )
);
var SvgBookmarkAddFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BookmarkAddFilled_default = SvgBookmarkAddFilled;

export { BookmarkAddFilled_default as default };
